import { render } from "./IconCogSolid.vue?vue&type=template&id=4112f336"
import script from "./IconCogSolid.vue?vue&type=script&lang=js"
export * from "./IconCogSolid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__